import React, {useEffect} from 'react';
import {useMutation} from "react-query";
import {useNavigate, useParams} from "react-router-dom";
import * as Yup from "yup";
import {useFormik} from "formik";

import {Button, Input} from "../../components/common";
import {ALERT_TYPES, INPUT_TYPES, ROUTES} from "../../types";
import {useAlert} from "../../components/common/Alert";

interface ISchema {
  [key: string]: string;
  password: string;
  repeat_password: string;
}

const SetNewPassword = () => {
  const { setAlert } = useAlert();
  const navigate = useNavigate();
  const { token } = useParams();

  const checkValidateToken = useMutation(["resetValidateToken"], {
    onMutate: (data: { token: string }) => {},
    onError: (e: any) => {
      if (e.response.status === 404) {
        setAlert('Время ссылки истекло!', ALERT_TYPES.ERROR);
      } else {
        setAlert(`${Object.values(e.response.data)[0]}`, ALERT_TYPES.ERROR);
      }

      navigate(ROUTES.SIGN_IN);
    }
  })

  const setNewPass = useMutation(["setNewPassword"], {
    onMutate: (data: { password: string; token: string; }) => {},
    onSuccess: () => {
      setAlert('Пароль успешно изменен!', ALERT_TYPES.SUCCESS);
      navigate(ROUTES.SIGN_IN);
    },
    onError: (e: any) => {
      e.response.data.password?.map((i: string) => setAlert(i, ALERT_TYPES.ERROR));
    }
  })

  useEffect(() => {
    if (token) {
      checkValidateToken.mutate({ token });
    }
  }, []);

  const validationSchema: Yup.Schema<ISchema> = Yup.object().shape({
    password: Yup.string().required('Пароль не может быть пустым')
      ?.min(8, 'Пароль должен содержать минимум 8 символов'),
    repeat_password: Yup.string()
      ?.required('Поле не может быть пустым')
      ?.min(8, 'Пароль должен содержать минимум 8 символов')
      ?.oneOf([Yup.ref('password'), ''], 'Пароли должны совпадать'),
  });

  const submitForm = async (values: any) => {
    const { password } = values;
    if (token) {
      await setNewPass.mutate({ password, token })
    }
  }

  const formik = useFormik({
    initialValues: {
      password: '',
      repeat_password: '',
    },
    validationSchema: validationSchema,
    onSubmit: submitForm
  });

  const {
    errors, touched
  } = formik;

  const handleSubmit = () => formik.handleSubmit();

  return (
    <div className="bg-signIn bg-no-repeat bg-center bg-cover w-full h-screen flex items-center justify-center">
      <div className="px-5 flex flex-col w-1/2 lg:w-full">
        <p className="text-[14px] leading-[24px] font-medium text-black mt-4">Введите новый пароль</p>
        <Input
          className="w-full"
          id="password"
          name="password"
          type={INPUT_TYPES.PASSWORD}
          placeholder="Введите новый пароль"
          onChange={formik.handleChange}
          error={touched?.password ? errors?.password : false}
        />

        <p className="text-[14px] leading-[24px] font-medium text-black mt-4">Повторите новый пароль</p>
        <Input
          className="w-full"
          id="repeat_password"
          name="repeat_password"
          type={INPUT_TYPES.PASSWORD}
          placeholder="Повторите новый пароль"
          onChange={formik.handleChange}
          error={touched?.repeat_password ? errors?.repeat_password : false}
        />

        <Button
          title={'Отправить'}
          onClick={handleSubmit}
          className="w-full mt-6"
        />
      </div>
    </div>
  )
};

export default SetNewPassword;
